import { mvxApiUrl } from "src/config";

const API_URL = mvxApiUrl;

export async function getCurrentEpoch(): Promise<number> {
    try {
        console.log('Fetching epoch from:', `${API_URL}/stats`);
        const response = await fetch(`${API_URL}/stats`);
        const data = await response.json();
        console.log('Current epoch:', data.epoch);
        return data.epoch;
    } catch (error) {
        console.error('Error fetching epoch:', error);
        return 0;
    }
} 